import { Trash } from '@phosphor-icons/react';

export default Trash;
